import type {Me} from "../../core/types";
import {useMeStore} from "../../core/store/me";

export class RoutingService {
  getHasHomeSection() {
    const me = useMeStore.getState().me;
    return (
      me &&
      (me.isResident ||
        me.isOfficer ||
        me.isPatrolOfficer ||
        me.isDispatch ||
        me.isPostCommander ||
        me.isSupervisor ||
        me.isSeniorSupervisor ||
        me.isDispatchSupervisor)
    );
  }

  /** Sidebar Management + Admin panel — field staff use main nav + quick actions only. */
  getCanAccessManagementAndAdminPanelNav(me: Me | null | undefined) {
    if (!me) return false;
    if (me.isOfficer || me.isPatrolOfficer) return false;
    return true;
  }
}

export const routingService = new RoutingService();
